import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-batch-export",
  "use": "icon-batch-export-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-batch-export\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 0v810.496h-171.072V1024H0V170.88h213.696V0H1024z m-256.384 256.192H85.312v682.496h682.304V256.192zM473.984 386.304l211.072 211.072-211.072 211.2-60.352-60.352 108.096-108.16H173.12V554.752h348.672l-108.16-108.16 60.352-60.288z m464.64-300.992H299.072v85.504h553.92v554.368h85.76V85.312z\" p-id=\"3775\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol